export const parametersComparisonCard = {
  height: '100%',
}

export const parametersComparisonCardContent = {
  pt: 0,
}
